import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_PromptList = _resolveComponent("PromptList")!
  const _component_PromptImportErrorDialog = _resolveComponent("PromptImportErrorDialog")!
  const _component_PromptForm = _resolveComponent("PromptForm")!
  const _component_EntryDialog = _resolveComponent("EntryDialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["p-p-2", {'content': !_ctx.isContext && !_ctx.showNoLlmClassHint, 'child-content': !_ctx.isContext && _ctx.showNoLlmClassHint}])
  }, [
    (_ctx.showNoLlmClassHint)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          severity: "warn",
          closable: false
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.isContext ? _ctx.$t('Squeeze.Prompts.NoLlmDocumentClassHint') : _ctx.$t('Squeeze.Prompts.NoLlmClassHint')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_PromptList, {
      rows: _ctx.filteredPrompts,
      documentClasses: _ctx.dialogDocumentClasses,
      allFields: _ctx.allFields,
      companyOptions: _ctx.companyOptions,
      creditorOptions: _ctx.creditorOptions,
      loading: _ctx.isContext ? _ctx.contextLoading : _ctx.promptsLoading,
      hasLlmClass: _ctx.hasLlmClass,
      showNoLlmClassHint: _ctx.showNoLlmClassHint,
      context: _ctx.isContext,
      lineItem: _ctx.lineItem,
      exporting: _ctx.exporting,
      importing: _ctx.importing,
      onOpenEntryDialog: _ctx.openEntryDialog,
      onDeleteEntry: _ctx.deleteEntry,
      onInlineEdit: _ctx.onInlineEdit,
      onExportPrompts: _ctx.exportPrompts,
      onImportPrompts: _ctx.openImportFileSelection
    }, null, 8, ["rows", "documentClasses", "allFields", "companyOptions", "creditorOptions", "loading", "hasLlmClass", "showNoLlmClassHint", "context", "lineItem", "exporting", "importing", "onOpenEntryDialog", "onDeleteEntry", "onInlineEdit", "onExportPrompts", "onImportPrompts"]),
    (!_ctx.isContext)
      ? (_openBlock(), _createElementBlock("input", {
          key: 1,
          ref: "importFileInput",
          class: "import-file-input",
          type: "file",
          accept: "application/json,.json",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onImportFileSelected && _ctx.onImportFileSelected(...args)))
        }, null, 544))
      : _createCommentVNode("", true),
    (!_ctx.isContext)
      ? (_openBlock(), _createBlock(_component_PromptImportErrorDialog, {
          key: 2,
          show: _ctx.showImportErrors,
          errors: _ctx.importErrors,
          loading: _ctx.importing,
          onOnClose: _ctx.onCloseImportErrors,
          onOnConfirm: _ctx.startImportIgnoringErrors
        }, null, 8, ["show", "errors", "loading", "onOnClose", "onOnConfirm"]))
      : _createCommentVNode("", true),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showDialog,
      onOnClose: _ctx.onCloseDialog,
      onOnConfirm: _ctx.saveFromDialog,
      loading: _ctx.saving,
      message: _ctx.message,
      messageType: _ctx.messageType,
      headerText: _ctx.headerText,
      showKeepDialogOpen: !_ctx.promptEntry.id,
      width: '60rem'
    }, {
      content: _withCtx(() => [
        _createVNode(_component_PromptForm, {
          ref: "promptFormElement",
          promptEntry: _ctx.promptEntry,
          documentClasses: _ctx.dialogDocumentClasses,
          fields: _ctx.fields,
          companyOptions: _ctx.companyOptions,
          creditorOptions: _ctx.creditorOptions,
          showErrorMessage: _ctx.showErrorMessage,
          readonlyFieldName: _ctx.isContext,
          onUpdate: _ctx.onUpdate,
          onClassChanged: _ctx.onClassChanged
        }, null, 8, ["promptEntry", "documentClasses", "fields", "companyOptions", "creditorOptions", "showErrorMessage", "readonlyFieldName", "onUpdate", "onClassChanged"])
      ]),
      _: 1
    }, 8, ["show", "onOnClose", "onOnConfirm", "loading", "message", "messageType", "headerText", "showKeepDialogOpen"])
  ], 2))
}